function StopLocation(customer, route) {
  this.id = customer.stopLocationId;
  this.routeSequence = customer.routeSequence;
  this.address = customer.fullAddress;
  this.latitude = customer.latitude;
  this.longitude = customer.longitude;
  this.customers = [customer];
  this.route = route;
}

StopLocation.prototype.addCustomer = function(customer) {
  this.customers.push(customer);
};

StopLocation.prototype.deliveries = function() {
  return this.customers.reduce(function(deliveries, customer) {
    return deliveries.concat(customer.deliveries);
  }, []);
};

StopLocation.prototype.deliveryCount = function() {
  return this.customers.reduce(function(count, customer) {
    return count + customer.deliveries.length;
  }, 0);
};

StopLocation.prototype.customerNotCancelledCount = function() {
  return this.customers.reduce(function(count, customer) {
    return count + customer.notCancelled();
  }, 0);
};

StopLocation.prototype.notCancelled = function() {
  return this.customers.some(function(customer) {
    return customer.notCancelled();
  });
};

StopLocation.prototype.allDelivered = function() {
  if (! this.notCancelled()) return false; // All cancelled - none have been handled by driver

  return this.customers.every(function(customer) {
    return customer.allDelivered() || ! customer.notCancelled();
  });
};

StopLocation.prototype.anyDeviations = function() {
  return this.customers.some(function(customer) {
    return customer.anyDeviations();
  });
};

StopLocation.prototype.anyComingNotifications = function() {
  return this.customers.some(function(customer) {
    return customer.hasReceivedComingSms();
  });
};

StopLocation.prototype.anyUnAccountedDeliveries = function() {
  return this.customers.some(function(customer) {
    return customer.anyUnAccountedDeliveries();
  });
};

StopLocation.prototype.updateRouteSequence = function(data) {
  this.routeSequence = data.routeSequence;
};


module.exports = StopLocation;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/stopLocation.js
 ** module id = 15
 ** module chunks = 1
 **/